import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";
import { designTokens } from "theme";
import * as env from "shared/env";

export const styles = (theme: Theme) => {
	return ({
		layout: {
			display: "flex",
			minHeight: "100vh",
		},
		left: {
			width: 300,
			position: "sticky",
			top: 0,
			flexGrow: 0,
			flexShrink: 0,
			height: "100vh",
			display: "flex",
			flexDirection: "column",
			zIndex: 1200,
			"@media (max-width: 960px)": {
				transitionProperty: "left",
				transitionDuration: "0.25s",
				transitionTimingFunction: "ease-in-out",
				position: "fixed",
				left: -305,
				"&.show": {
					left: 0,
				},
				"&:not(.show)": {
					"& .backdrop": {
						opacity: 0,
						visibility: "hidden",
					},
				},
				"& .backdrop": {
					transitionProperty: "opacity visibility",
					transitionDuration: "0.25s",
					transitionTimingFunction: "ease-in-out",
					top: 0,
					left: 0,
					right: 0,
					bottom: 0,
					zIndex: -1,
					position: "fixed",
					opacity: 0.5,
					backgroundColor: "black",
				},
			},
		},
		leftTop: {
			display: "flex",
			flexDirection: "row",
			flexShrink: 0,
			boxSizing: "border-box",
			backgroundColor: theme.palette.background.default,
			color: theme.palette.text.primary,
			height: 100,
			padding: 8,
			borderBottom: `1px solid ${theme.palette.custom.divider}`,
		},
		logoWrapper: {
			flex: 1,
			display: "flex",
			alignItems: "center",
			justifyContent: "center",
		},
		logo: {
			width: "100%",
			height: "100%",
			objectFit: "contain",
			objectPosition: "top",
		},
		logoReseller: {
			width: "80%",
			height: "100%",
			objectFit: "contain",
		},
		logoMissing: {
			textAlign: "center",
			width: "100%",
			fontSize: 26,
			overflow: "hidden",
			textOverflow: "ellipsis",
			color: theme.palette.secondary.main,
		},
		toggle: {
			width: 24,
			cursor: "pointer",
			alignSelf: "center",
			"@media (min-width: 960px)": {
				display: "none",
			},
		},
		leftBottom: {
			flexGrow: 1,
			overflowY: "auto",
			backgroundColor: theme.palette.custom.sidebarBackground,
			borderRight: `1px solid ${theme.palette.custom.divider}`,
			paddingBottom: 60,
			scrollbarWidth: "none",
			"&::-webkit-scrollbar": {
				display: "none",
			},
		},
		namePlate: {
			backgroundColor: theme.palette.primary.main,
			display: "flex",
			flexDirection: "column",
			alignItems: "center",
			padding: 15,
			marginBottom: 20,
		},
		line1: {
			fontSize: 20,
			color: theme.palette.primary.contrastText,
			textAlign: "center",
			marginBottom: 10,
		},
		line2: {
			fontSize: 18,
			color: theme.palette.primary.contrastText,
		},
		right: {
			flex: 1,
			display: "flex",
			flexDirection: "column",
			width: 1, // hack
		},
		navBar: {
			backgroundColor: theme.palette.background.default,
			borderBottom: `1px solid ${theme.palette.custom.divider}`,
			padding: 8,
			height: "100px",
			justifyContent: "center",
			"& .MuiToolbar-root": {
				paddingLeft: 0,
				paddingRight: 0,
			},
		},
		flexGrow: {
			flexGrow: 0,
			width: 0,
		},
		topMenuWrapper: {
			flex: 1,
			minWidth: 0,
			overflow: "hidden",
		},
		header: {
			background: theme.palette.custom.sidebarBackground,
			color: theme.palette.custom.navText,
			padding: 0,
			zIndex: 1000,
			"& h1": {
				display: "flex",
				alignItems: "center",
				color: theme.palette.custom.navText,
				marginBottom: 0,
				"& svg": {
					display: "none",
				},
			},
		},
		headerContent: {
			flex: 1,
			minWidth: 0,
		},
		toolbar: {
			overflow: "hidden",
			marginRight: 0,
			paddingLeft: 32,
			paddingRight: 32,
			paddingTop: 32,
			paddingBottom: 0,
			minHeight: "auto",
			"@media (min-width: 600px)": {
				minHeight: "auto",
			},
		},
		content: {
			flex: 1,
			backgroundColor: designTokens.colors.grayLight,
			display: "flex",
			flexDirection: "column",
		},
		mainContainer: {
			flex: 1,
			padding: "16px 32px 0",
			display: "flex",
			flexDirection: "column",
		},
		fixedWidthContent: {
			display: "flex",
			alignItems: "center",
			flexWrap: "nowrap",
			flexDirection: "column",
		},
		fixedWidthChild: {
			maxWidth: 1024,
			width: "100%",
			flex: 1,
			display: "flex",
			flexDirection: "column",
		},
		iframeContainer: {
			flex: 1,
			display: "flex",
			flexDirection: "column",
			"& iframe": {
				flex: 1,
				border: "none",
			},
		},
	} satisfies Record<string, CSSObject>);
};
